import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import { Program, ProgramsData } from '@shared/types/programs';
import { API } from '@src/api/index.ts';
import { UpdateProgramDto } from '@src/api/programs.ts';
import { queryClient } from '@src/api/query-client.ts';

export const useUpdateProgramMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateProgramDto) => await API.programs.update(params),
    onSuccess: async (response) => {
      queryClient.setQueriesData(
        { queryKey: ['programsHistory'] },
        (oldData: InfiniteData<ProgramsData>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: page.results.map((item) =>
                item.pk === response.data.pk ? { ...item, ...response.data } : item
              ),
            })),
          };
        }
      );

      queryClient.setQueriesData(
        { queryKey: ['programs'] },
        (oldData: InfiniteData<ProgramsData>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: page.results.map((item) =>
                item.pk === response.data.pk ? { ...item, ...response.data } : item
              ),
            })),
          };
        }
      );
      queryClient.setQueriesData(
        { queryKey: ['program', String(response.data.pk)] },
        (oldData: Program) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            ...response.data,
          };
        }
      );

      await queryClient.invalidateQueries({ queryKey: ['program', String(response.data.pk)] });
      queryClient.invalidateQueries({ queryKey: ['programs'] });
      queryClient.invalidateQueries({ queryKey: ['programsHistory'] });
    },
  });
};
